import { countries } from '../constants';
import { connectEditor } from './connect-editor';
import MissingSKUs from './utils/MissingSKUs';

export default connectEditor(
  ({ quote, quoteLinesById, productsById }, { id }) => {
    const quoteLine = quoteLinesById[id];
    const product = productsById[quoteLine.productId];

    const countryCodes = countries
      .filter(({ countryCode }) => quoteLine.countrySplit[countryCode] > 0)
      .map(({ countryCode }) => countryCode);

    return {
      check: !!product.checkSKUs,
      brandIds: quote.brandIds,

      categories: quoteLine.categories,
      genders: quoteLine.genders,
      countryCodes,
    };
  },
)(MissingSKUs);
